import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=4d6ee356&scoped=true&functional=true&"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./VxBreadcrumb.vue?vue&type=style&index=0&id=4d6ee356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4d6ee356",
  null
  
)

export default component.exports